var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticStyle:{"font-weight":"400","margin":"0px !important","padding":"0px !important"}},[_vm._v("\n    "+_vm._s(_vm.parseCurrency(
        parseFloat((_vm.data.FIYAT * _vm.data.vat) / 100) + parseFloat(_vm.data.FIYAT)
      ))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }